import React, { FC } from "react";

import Svg from "./Svg";
import colors from "../../utils/colorConstants";

interface Props {
  width: string;
  height: string;
  outlineColor?: string;
  fill?: string;
  background?: string;
  className?: string;
}

const GooglePlayStore: FC<Props> = ({
  className,
  height,
  width,
  fill = colors.lapel,
  outlineColor,
  background = "none",
}) => {
  return (
    <Svg
      className={className}
      height={height}
      width={width}
      viewBox="0 0 130 40"
      title="Google Play Store icon"
    >
      <g fill="none" fillRule="evenodd">
        <rect
          width="126.8"
          height="38.8"
          x=".6"
          y=".6"
          fill={background}
          rx="6"
        />
        <g fill={fill}>
          <path d="M11.3 9.4c-.3.3-.4.7-.4 1.2v19.9c0 .5.1 1 .4 1.2l11.2-11v-.3l-11.2-11zm14.9 15l-3.7-3.7v-.3l3.7-3.7 4.5 2.6c1.2.7 1.2 1.8 0 2.6l-4.4 2.4h-.1z" />
          <path d="M26.3 24.3l-3.8-3.8-11.2 11.2c.4.5 1.1.5 1.9 0l13-7.4m0-7.5l-13-7.5c-.8-.4-1.5-.4-2 0l11.3 11.3 3.8-3.8z" />
        </g>
        <path
          fill={fill}
          d="M97.9 29.8h1.7V18.6h-1.7v11.2zm15-7.2l-1.9 4.9-2-4.9h-1.8l3 6.8-1.7 3.8h1.7l4.6-10.6H113zm-9.4 6c-.6 0-1.3-.3-1.3-1 0-.9 1-1.2 1.7-1.2a3 3 0 011.6.4 2 2 0 01-2 1.7zm.2-6.2c-1.2 0-2.5.5-3 1.7l1.5.6c.3-.6.9-.8 1.5-.8.9 0 1.7.5 1.8 1.5-.3-.1-1-.4-1.8-.4-1.6 0-3.2 1-3.2 2.6 0 1.5 1.3 2.4 2.8 2.4 1.1 0 1.7-.5 2.1-1v.8h1.7v-4.3c0-2-1.5-3.1-3.4-3.1zM93.3 24H91v-3.8h2.3a2 2 0 012 1.9c0 .9-.7 2-2 2zm0-5.4h-4v11.2h1.6v-4.2h2.4c1.8 0 3.7-1.4 3.7-3.5 0-2.2-1.9-3.5-3.7-3.5zm-21.9 10c-1.2 0-2.1-1-2.1-2.4 0-1.3 1-2.3 2.1-2.3s2 1 2 2.3c0 1.4-.9 2.4-2 2.4zm2-5.3h-.1a2.6 2.6 0 00-2-.9 3.8 3.8 0 00-3.7 3.8c0 2.2 1.7 3.9 3.7 3.9.9 0 1.6-.5 2-1v.6c0 1.5-.8 2.3-2 2.3a2.1 2.1 0 01-2-1.4l-1.4.6a3.6 3.6 0 003.4 2.3c2 0 3.6-1.2 3.6-4v-6.9h-1.6v.7zm2.7 6.5h1.6V18.6h-1.6v11.2zm4.1-3.7a2.1 2.1 0 012-2.2c.7 0 1.2.3 1.4.8l-3.4 1.4zm5.2-1.3c-.3-.8-1.3-2.4-3.2-2.4-2 0-3.6 1.6-3.6 3.8a3.7 3.7 0 003.8 3.8 3.8 3.8 0 003.1-1.7l-1.3-.8a2.2 2.2 0 01-1.9 1 2 2 0 01-1.8-1.1l5-2.1v-.5zm-40.6-1.2v1.6h3.8a3.4 3.4 0 01-.8 2 4 4 0 01-3 1.2 4.3 4.3 0 01-4.3-4.3 4.3 4.3 0 017.2-3.1l1.1-1.2a5.7 5.7 0 00-4-1.6 6 6 0 00-6 6 6 6 0 006 5.9c1.7 0 3-.6 4.1-1.7a5.3 5.3 0 001.4-3.8v-1h-5.5zm10 5c-1.2 0-2.2-1-2.2-2.4 0-1.3 1-2.3 2.1-2.3 1.2 0 2.2 1 2.2 2.3 0 1.4-1 2.3-2.2 2.3zm0-6.2a3.8 3.8 0 00-4 3.8c0 2.2 1.8 3.8 4 3.8a3.8 3.8 0 003.7-3.8 3.8 3.8 0 00-3.8-3.8zm8.3 6.2c-1.2 0-2.2-1-2.2-2.4 0-1.3 1-2.3 2.2-2.3 1.1 0 2.1 1 2.1 2.3 0 1.4-1 2.3-2.1 2.3zm0-6.2a3.8 3.8 0 00-3.9 3.8c0 2.2 1.8 3.8 3.9 3.8a3.8 3.8 0 003.8-3.8 3.8 3.8 0 00-3.8-3.8zM45.4 12.2c0 .9-.2 1.5-.7 2-.6.6-1.3 1-2.2 1a3 3 0 01-2.2-1 3 3 0 01-1-2.2 3 3 0 011-2.2 3 3 0 012.2-1l1.2.3 1 .7-.6.5a2 2 0 00-1.6-.7c-.7 0-1.2.2-1.7.7a2.3 2.3 0 00-.7 1.7c0 .7.3 1.3.7 1.7.5.5 1 .7 1.7.7.6 0 1.2-.2 1.6-.7.3-.3.5-.7.5-1.2h-2.1v-.7h2.9v.4"
        />
        <path
          stroke={fill}
          strokeWidth=".2"
          d="M45.4 12.2c0 .9-.2 1.5-.7 2-.6.6-1.3 1-2.2 1a3 3 0 01-2.2-1 3 3 0 01-1-2.2 3 3 0 011-2.2 3 3 0 012.2-1l1.2.3 1 .7-.6.5a2 2 0 00-1.6-.7c-.7 0-1.2.2-1.7.7a2.3 2.3 0 00-.7 1.7c0 .7.3 1.3.7 1.7.5.5 1 .7 1.7.7.6 0 1.2-.2 1.6-.7.3-.3.5-.7.5-1.2h-2.1v-.7h2.9v.4z"
        />
        <path fill={fill} d="M50 9.7h-2.7v2h2.5v.7h-2.5v1.9H50v.7h-3.5V9H50z" />
        <path
          stroke={fill}
          strokeWidth=".2"
          d="M50 9.7h-2.7v2h2.5v.7h-2.5v1.9H50v.7h-3.5V9H50z"
        />
        <path fill={fill} d="M53.3 15h-.8V9.7h-1.7V9H55v.7h-1.7z" />
        <path
          stroke={fill}
          strokeWidth=".2"
          d="M53.3 15h-.8V9.7h-1.7V9H55v.7h-1.7z"
        />
        <path fill={fill} d="M58 15h.7V9H58z" />
        <path stroke={fill} strokeWidth=".2" d="M58 15h.7V9H58z" />
        <path fill={fill} d="M62.1 15h-.7V9.7h-1.7V9h4.1v.7h-1.7z" />
        <path
          stroke={fill}
          strokeWidth=".2"
          d="M62.1 15h-.7V9.7h-1.7V9h4.1v.7h-1.7z"
        />
        <path
          fill={fill}
          d="M67.8 13.7c.4.5 1 .7 1.6.7a2.2 2.2 0 001.6-.7c.5-.4.7-1 .7-1.7s-.2-1.3-.7-1.7a2.2 2.2 0 00-1.6-.7 2.2 2.2 0 00-1.6.7A2.4 2.4 0 0067 12c0 .7.2 1.3.7 1.7m3.8.5a3 3 0 01-2.2 1 3 3 0 01-3-3.2 3 3 0 013-3.1 3 3 0 013 3.1 3 3 0 01-.8 2.2"
        />
        <path
          stroke={fill}
          strokeWidth=".2"
          d="M67.8 13.7c.4.5 1 .7 1.6.7a2.2 2.2 0 001.6-.7c.5-.4.7-1 .7-1.7s-.2-1.3-.7-1.7a2.2 2.2 0 00-1.6-.7 2.2 2.2 0 00-1.6.7A2.4 2.4 0 0067 12c0 .7.2 1.3.7 1.7zm3.8.5a3 3 0 01-2.2 1 3 3 0 01-3-3.2 3 3 0 013-3.1 3 3 0 013 3.1 3 3 0 01-.8 2.2z"
        />
        <path fill={fill} d="M73.6 15V9h1l2.8 4.7V9h.8v6h-.8l-3-4.9V15z" />
        <path
          stroke={fill}
          strokeWidth=".2"
          d="M73.6 15V9h1l2.8 4.7h0V9h.8v6h-.8l-3-4.9h0V15z"
        />
        <rect
          width="126.8"
          height="38.8"
          x=".6"
          y=".6"
          stroke={outlineColor || fill}
          strokeWidth="1.2"
          rx="6"
        />
      </g>
    </Svg>
  );
};

export default React.memo(GooglePlayStore);
